import "core-js/modules/es.array.sort.js";
import { dateGlueUtils, SInputDate, timestampIntervalUtils } from '@strana-artw/ui-kit';
import { computed, defineComponent, ref } from 'vue';
import { validateDateInterval } from '@/shared/lib';
export default defineComponent({
  name: 'SpecDate',
  components: {
    SInputDate: SInputDate
  },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: {
      type: String,
      default: 'Период работы'
    },
    facet: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  emits: ['change', 'error'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var inputDateRef = ref();
    var errorMessage = ref('');
    var hasError = computed(function () {
      return Boolean(errorMessage.value);
    });
    var dateModel = computed({
      get: function get() {
        var preresult = dateGlueUtils.fromVuetifyInterval(props.value);
        return timestampIntervalUtils.isIntervalNonNullish(preresult) ? preresult : {
          from: undefined,
          to: undefined
        };
      },
      set: function set(value) {
        var _inputDateRef$value;
        var inputValue = (_inputDateRef$value = inputDateRef.value) === null || _inputDateRef$value === void 0 ? void 0 : _inputDateRef$value.$refs.inputRef._data.lazyValue;
        var preresult = dateGlueUtils.toVuetifyInterval(value);
        // Кейс некорректного ввода с клавиатуры (например, 66.66.6666-66.66.6666)
        if (preresult.length === 0 && inputValue) {
          errorMessage.value = 'Некорректный формат интервала дат';
          emit('error', {
            hasError: true,
            message: errorMessage.value
          });
          return;
        }
        // Кейс некорректного ввода интервала (например, 12.01.2025-12.01.2024)
        if (inputValue && !validateDateInterval(inputValue)) {
          errorMessage.value = 'Некорректный формат интервала дат';
          emit('error', {
            hasError: true,
            message: errorMessage.value
          });
          return;
        }
        // При очистке поля
        if (preresult.length === 0 && !inputValue && typeof inputValue === 'string') {
          errorMessage.value = '';
          emit('error', {
            hasError: false,
            message: ''
          });
          emit('change', preresult.sort());
          return;
        }
        if (preresult.length > 0) {
          errorMessage.value = '';
          emit('error', {
            hasError: false,
            message: ''
          });
          emit('change', preresult.sort());
          return;
        }
        errorMessage.value = '';
        emit('error', {
          hasError: false,
          message: ''
        });
      }
    });
    var getErrorState = function getErrorState() {
      return {
        hasError: hasError.value,
        message: errorMessage.value
      };
    };
    var isValid = function isValid() {
      return !hasError.value;
    };
    return {
      dateModel: dateModel,
      inputDateRef: inputDateRef,
      errorMessage: errorMessage,
      hasError: hasError,
      getErrorState: getErrorState,
      isValid: isValid,
      vuetifyParser: dateGlueUtils.createCustomParser('YYYY-MM-DD')
    };
  }
});